import { PRIMARY_LOCALE } from "routes/healthForms/types/common";
import React from "react";
import { useTranslation } from "react-i18next";
import { Box, Button } from "@material-ui/core";
import { Add } from "@material-ui/icons";
import { CardContainer } from "routes/createContent/components/styles";
import { useGetTemplates } from "routes/createContent/api/useGetTemplates";
import { LibraryItem } from "../../components/LibraryItem/LibraryItem";
import { Link, useHistory } from "react-router-dom";
import { Area } from "types";
import { JointImage } from "shared/JointImage";
import { Loading } from "shared";

export const Templates: React.VFC = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const { data: templates, isLoading, error } = useGetTemplates();

  if (isLoading) {
    return <Loading />;
  }

  if (error) {
    return <p>{t("errors.generic")}</p>;
  }

  return (
    <div>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <h1 style={{ margin: 0 }}>Templates</h1>
        <Button
          color="primary"
          variant="contained"
          startIcon={<Add />}
          component={Link}
          to={Area.CreateContent_Templates_New}
        >
          New template
        </Button>
      </Box>

      <CardContainer>
        {templates?.map(template => {
          const name = template.name[PRIMARY_LOCALE.code] || String(template.id);

          return (
            <LibraryItem
              key={template.id}
              author={undefined}
              checked={false}
              id={template.id}
              image={template.key ? <JointImage id={template.key} /> : undefined}
              title={name as string}
              onClick={() => {
                history.push(`${Area.CreateContent_Templates}/${template.id}`);
              }}
            />
          );
        })}
      </CardContainer>
    </div>
  );
};
